<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="11" md="11">
        <!-- loading控制加载条，初始为false不显示 -->
        <v-data-table
          :headers="headers"
          :items="issueDict"
          sort-by="id"
          class="elevation-1"
          :loading="loading"
          :search="search"
          :items-per-page="15"
        >
          <!-- table顶部 标题... -->
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-app-bar-nav-icon><v-icon color="accent" x-large>mdi-format-list-text</v-icon></v-app-bar-nav-icon>
              <v-toolbar-title style="color: #1976D2; font-size: 30px;">ISSUES列表</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <!-- 通过slot自定义表头 -->
          <template v-slot:[`header.id`] ="{ header }">
            <span style="color: #1976D2; font-size: 17px;">{{ header.text }}</span>                
          </template>
          <template v-slot:[`header.usernameGithub`] ="{ header }">
            <span style="color: #1976D2; font-size: 17px;">{{ header.text }}</span>
          </template>
          <template v-slot:[`header.issueLabel`] ="{ header }">
            <span style="color: #1976D2; font-size: 17px;">{{ header.text }}</span>
          </template>
          <template v-slot:[`header.issueTitle`] ="{ header }">
            <span style="color: #1976D2; font-size: 17px;">{{ header.text }}</span>
          </template>
          <template v-slot:[`header.githubLink`] ="{ header }">
            <span style="color: #1976D2; font-size: 17px;">{{ header.text }}</span>
          </template>
          <template v-slot:[`header.actions`] ="{ header }">
            <span style="color: #1976D2; font-size: 17px;">{{ header.text }}</span>
          </template>
          <template v-slot:[`header.issueStatus`] ="{ header }">
            <span style="color: #1976D2; font-size: 17px;">{{ header.text }}</span>
          </template>
          <template v-slot:[`header.isReplied`] ="{ header }">
            <span style="color: #1976D2; font-size: 17px;">{{ header.text }}</span>
          </template>
          <template v-slot:[`header.delete`] ="{ header }">
            <span style="color: red; font-size: 17px;">{{ header.text }}</span>
          </template>
          <!-- 通过slot自定义表体 -->
          <template v-slot:[`item.issueLabel`]="{ item }">
            <v-chip class="ma-0" :color="item.issueLabel=='bug'?'red':'pink'" text-color="white">
              {{ item.issueLabel }}
            </v-chip>
          </template>
          <template v-slot:[`item.issueTitle`]="{ item }">
            <router-link target="_blank" style="text-decoration-line:none;" :to="{path: '/issue_details', query: {id: item.id}}">
              {{ item.issueTitle }}
            </router-link>
          </template>
          <template v-slot:[`item.githubLink`]="{ item }">
            <a target="_blank" style="text-decoration-line:none;" :href="item.githubLink" v-if="item.githubLink">
              <v-icon
                class="mr-3"
                color="accent"
              >
                mdi-github
              </v-icon>
            </a>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <!-- <router-link target="_blank" style="text-decoration-line:none;" :to="{path: '/bug_view', query: {id: item.id}}">
              <v-icon
                class="mr-3"
                color="accent"
              >
                mdi-eye
              </v-icon>
            </router-link> -->
            <router-link :target="$long_judge_sentence(item.usernameGithub)?'':'_blank'" style="text-decoration-line:none;" :to="$long_judge_sentence(item.usernameGithub)?{}:{path: '/issue_update', query: {id: item.id}}">
              <v-icon
                v-if="item.usernameGithub!='tourist'"
                class="mr-4"
                color="accent"
                :disabled="$long_judge_sentence(item.usernameGithub)"
              >
                mdi-pencil
              </v-icon>
            </router-link>
          </template>
          <!-- 问题状态列 open reopen close -->
          <template v-slot:[`item.issueStatus`]="{ item }" v-if="show_issue_status">
            <!-- 游客 只显示问题所处状态 -->
            <v-chip :color="item.issueStatus == 'open' ? 'green' : (item.issueStatus == 'reopen' ? 'blue' : 'red')" 
              v-if="!$cookies.get('username_github')">
              {{item.issueStatus}}
            </v-chip>
            <!-- 管理员 显示所有Issue的状态操作按钮 -->
            <v-select menu-props="offset-y" dense v-model="item.issueStatus" :items="getStatusOptions(item.issueStatus)" solo item-color="primary" hide-details hide-selected chips flat
             @input='updateIssueStatus(item.id, item.issueStatus)' v-else-if="$is_admin($cookies.get('username_github'))">
              <template v-slot:selection="{ item }">
                <v-chip :color="item == 'open' ? 'green' : (item == 'reopen' ? 'blue' : 'red')">{{item}}</v-chip>
              </template>
            </v-select>
            <!-- 登录用户 属于自己的Issue的显示状态操作按钮 -->
            <v-select menu-props="offset-y" dense v-model="item.issueStatus" :items="getStatusOptions(item.issueStatus)" solo item-color="primary" hide-details hide-selected chips flat
             @input='updateIssueStatus(item.id, item.issueStatus)' v-else-if="$cookies.get('username_github')==item.usernameGithub">
              <template v-slot:selection="{ item }">
                <v-chip :color="item == 'open' ? 'green' : (item == 'reopen' ? 'blue' : 'red')">{{item}}</v-chip>
              </template>
            </v-select>
            <!-- 登录用户 不属于自己的Issue显示所处状态 -->
            <v-chip :color="item.issueStatus == 'open' ? 'green' : (item.issueStatus == 'reopen' ? 'blue' : 'red')" v-else>
              {{item.issueStatus}}
            </v-chip>
          </template>
          <!-- Admin列 -->
          <template v-slot:[`item.isReplied`]="{ item }" v-if="show_admin">
            <v-btn
              :color="item.isReplied ? 'grey' : 'accent'"
              @click="updateIssueReplied(item.id, item.isReplied)"
            >
              {{ item.isReplied ? '已答复' : '未答复'}}
            </v-btn>
          </template>
          <!-- 删除按钮列 -->
          <template v-slot:[`item.delete`]="{ item }" v-if="show_admin">
            <v-btn @click="deleteIssue(item.id)">
              X
            </v-btn>
          </template>
          <!-- 无数据显示 Reset 重新初始化/查询 -->
          <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="retrieveIssueList"
            >
              Reset
            </v-btn>
          </template>
        </v-data-table>
        <!-- 分页 -->
        <!-- <div class="text-center">
          <v-pagination
            v-model="pageIndex"
            :length="length"
            :total-visible="7"
            @input='pageChange'
          ></v-pagination>
        </div> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default({
  data: () => ({
    csrf_token: $cookies.get('csrftoken'),
    pageIndex: 1,
    issueCount: null,
    issueDict: [],
    // 控制加载条的显示
    loading: false,
    length: 1,
    headers: [
      {text: 'ID', value: 'id', align: 'start', sortable: true, width: '75px',},
      {text: '提交者', value: 'usernameGithub', sortable: false, width: '100px',},
      {text: '标签', value: 'issueLabel', sortable: false, width: '75px',},
      {text: '标题', value: 'issueTitle', sortable: false, width: '650px',},
      {text: 'Github', value: 'githubLink', align: 'right', sortable: false, width: '75px'},
      {text: 'Actions', value: 'actions', align: 'right', sortable: false, width: '75px'},
      {text: 'Status', value: 'issueStatus', align: 'center', sortable: true, width: '50px'},
    ],
    search: '',
    show_admin: true,
    show_issue_status: true,
  }),
  created () {
    this.retrieveIssueList()
    if(this.$is_admin(this.$cookies.get('username_github'))){
      this.headers.push({text: 'Admin', value: 'isReplied', align: 'center', sortable: true, width: '100px'})
      this.headers.push({text: 'D', value: 'delete', align: 'center', sortable: false, width: '30px'})
    }
  },
  methods: {
    // 取回问题列表
    retrieveIssueList () {
      let that = this
      that.loading = true
      this.$axios.get('/api/issues/',)
      .then(function(response){
        that.issueDict = response.data.data
        that.issueCount = response.data.data.length
        that.length = Math.ceil(that.issueCount/20)
        that.loading = false
      })
      .catch(function(error){
        that.loading = false
        that.$toast({
          text: '查询BUG失败，请尝试Reset或联系网站管理员',
          type: 'error',
          duration: 3000,
        })
      })
    },
    // pageChange(){
    //   this.retrieveIssueList()
    // },
    // 更改问题回复状态
    async updateIssueReplied(issue_id, isReplied){
      if(isReplied == true){
        var data = {'isReplied': false}
      }
      else{
        var data = {'isReplied': true}
      }
      var that = this
      await this.$axios.patch(`/api/issues/${issue_id}`, data, {headers: {"X-CSRFToken": that.csrf_token, "Content-Type": "application/json"}})
      .then(function(response){
        var dic = response.data
          that.$toast({
            text: dic.msg,
            type: 'success',
            duration: 1000,
          })
      })
      .catch(function(error){
        that.$toast({
          text: '无权限',
          type: 'error',
          duration: 1000,
        })
      })
      this.retrieveIssueList()
      this.show_admin = false
      await this.$nextTick(function(){
        this.show_admin = true
      });
    },
    async updateIssueStatus(issue_id, issueStatus) {
      var data = {'issueStatus': issueStatus}
      var that = this
      await this.$axios.patch(`/api/issues/${issue_id}`, data, {headers: {"X-CSRFToken": that.csrf_token, "Content-Type": "application/json"}})
      .then(function(response){
        var dic = response.data
          that.$toast({
            text: dic.msg,
            type: 'success',
            duration: 1000,
          })        
      })
      .catch(function(error){
        that.$toast({
          text: '无权限',
          type: 'error',
          duration: 1000,
        })
      })
      this.retrieveIssueList()
      this.show_issue_status = false
      await this.$nextTick(function(){
        this.show_issue_status = true
      });
    },
    async deleteIssue(issue_id) {
      alert("确认删除改条反馈")
      var that = this
      await this.$axios.delete(`/api/issues/${issue_id}`, {headers: {"X-CSRFToken": that.csrf_token, "Content-Type": "application/json"}})
      .then(function(response){
        var dic = response.data
          that.$toast({
            text: dic.msg,
            type: 'success',
            duration: 1000,
          })        
      })
      .catch(function(error){
        that.$toast({
          text: '无权限',
          type: 'error',
          duration: 1000,
        })
      })
      this.retrieveIssueList()
      this.show_issue_status = false
      await this.$nextTick(function(){
        this.show_issue_status = true
      });
    },
    getStatusOptions(issueStatus) {
      if(issueStatus=='open'){
        return ['open', 'closed']
      }
      if(issueStatus=='closed'){
        return ['closed', 'reopen']
      }
      if(issueStatus=='reopen'){
        return ['reopen', 'closed']
      }
    }
  },
})
</script>
